(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var widget = document.getElementById('bopi-quiz');
    if (!widget) return;

    var dataEl = document.getElementById('patch-design-data');
    if (!dataEl) return;

    var designs;
    try {
      designs = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!designs || !designs.length) return;

    var svgFor = {};
    document.querySelectorAll('template[data-patch-template]').forEach(function (tpl) {
      svgFor[tpl.getAttribute('data-patch-template')] = tpl.innerHTML.trim();
    });

    function artFor(id) {
      var d = findDesign(id);
      if (d && d.image) {
        return '<img src="' + d.image + '" alt="' + (d.label || '') + '" loading="lazy">';
      }
      return svgFor[id] || '';
    }

    function findDesign(id) {
      for (var i = 0; i < designs.length; i++) if (designs[i].id === id) return designs[i];
      return designs[0];
    }

    var questions = Array.prototype.slice.call(widget.querySelectorAll('.quiz-question'));
    var progressEl = document.getElementById('quiz-progress');
    var resultEl = document.getElementById('quiz-result');
    var scores = {};
    var currentIndex = 0;

    renderProgress();

    function renderProgress() {
      progressEl.innerHTML = '';
      questions.forEach(function (q, i) {
        var dot = document.createElement('span');
        dot.className = 'quiz-dot' + (i < currentIndex ? ' is-done' : i === currentIndex ? ' is-active' : '');
        progressEl.appendChild(dot);
      });
    }

    questions.forEach(function (question, index) {
      question.querySelectorAll('.quiz-answer').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var designId = btn.getAttribute('data-design');
          if (designId) scores[designId] = (scores[designId] || 0) + 1;

          question.classList.remove('is-active');
          question.classList.add('is-answered');

          if (index + 1 < questions.length) {
            currentIndex = index + 1;
            questions[currentIndex].classList.add('is-active');
            renderProgress();
          } else {
            currentIndex = questions.length;
            renderProgress();
            showResult();
          }
        });
      });
    });

    function showResult() {
      var winnerId = null;
      var winnerScore = -1;
      Object.keys(scores).forEach(function (id) {
        if (scores[id] > winnerScore) {
          winnerScore = scores[id];
          winnerId = id;
        }
      });
      if (!winnerId) winnerId = designs[0].id;

      var d = findDesign(winnerId);

      document.getElementById('quiz-result-art').innerHTML = artFor(d.id);
      document.getElementById('quiz-result-name').textContent = d.label;
      document.getElementById('quiz-result-story').textContent = d.story || '';

      document.getElementById('quiz-questions').style.display = 'none';
      progressEl.style.display = 'none';
      resultEl.hidden = false;

      var addBtn = document.getElementById('quiz-add-btn');
      addBtn.onclick = function () {
        if (!window.BopiCart) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        window.BopiCart.addToCart({ variantId: d.variantId, quantity: 2 }).then(function (result) {
          addBtn.textContent = result.ok ? 'Added!' : 'Try again';
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }, 1200);
        });
      };

      document.getElementById('quiz-retake-btn').addEventListener('click', function () {
        scores = {};
        currentIndex = 0;
        questions.forEach(function (q, i) {
          q.classList.remove('is-answered', 'is-active');
          if (i === 0) q.classList.add('is-active');
        });
        document.getElementById('quiz-questions').style.display = '';
        progressEl.style.display = '';
        resultEl.hidden = true;
        renderProgress();
      });
    }
  });
})();
